import React, { useState, useEffect } from 'react'
import { ImageUploader, Dialog, Toast } from 'antd-mobile'
import axios from 'axios'
import API_ROUTES from '../../api'

const UploadImgToOss = ({ onChange, value }) => {

    const [fileList, setFileList] = useState(value ? [{ url: value }] : []);

    useEffect(() => {
        // 外战队伍可留空队徽，空值不生成失效的图片缩略图。
        setFileList(value ? [{ url: value }] : []);
    }, [value]);


    const mockUploadOss = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        await axios.post(API_ROUTES.auth_uploadToOss, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            if (res.data.code === 200) {
                typeof onChange === 'function' && onChange(res.data.data)
                Toast.show({
                    icon: 'success',
                    content: '上传成功!',
                }
                )
            }
        })
        return {
            url: URL.createObjectURL(file),
        }
    }

    return (
        <span>
            <ImageUploader
                value={fileList}
                onChange={(info) => {
                    setFileList(info)
                }}
                upload={mockUploadOss}
                maxCount={1}
                onDelete={() => {
                    return Dialog.confirm({
                        content: '是否重新上传',
                    })
                }}
            />
        </span>
    )
}

export default UploadImgToOss;
